import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useNormalizePage = ({
    data,
    pagination,
    actionCreator
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!data?.body) {
            return;
        }

        const { items, total } = data.body;

        const lastPage = Math.max(
            1,
            Math.ceil(total / pagination.limit)
        );

        if (
            items.length === 0 &&
            pagination.page > lastPage
        ) {
            dispatch(
                actionCreator({
                    ...pagination,
                    page: lastPage,
                    start: (lastPage - 1) * pagination.limit
                })
            );
        }

    }, [
        data,
        pagination.page,
        pagination.limit,
        actionCreator,
        dispatch
    ]);
};
